export enum ThemeType {
  IDG = 'idg',
}

export interface UiState {
  isGlobalLoading: boolean
  organizationLogo: string | null
  currentThemeName: ThemeType
  currentThemeConfig: IThemeConfig | null
  themeError: string | null
}

export interface IThemeConfig {
  name: ThemeType
  version: string
  colors: {
    primary: string[]
    secondary?: string[]
    [key: string]: string[] | undefined
  }
  cssVariables: {
    [key: string]: string
  }
  components?: {
    [componentName: string]: {
      styles?: {
        [styleName: string]: {
          [property: string]: string | number
        }
      }
      defaultProps?: {
        [propName: string]: any
      }
    }
  }
  mantineConfig: {
    primaryColor: string
    primaryShade: { light: number; dark: number }
    fontFamily: string
    radius?: {
      [key: string]: string
    }
    defaultRadius?: string
    white?: string
    black?: string
    headings?: {
      fontFamily: string
    }
  }
}

export const THEME_FILE_MAP: Record<string, string> = {
  [ThemeType.IDG]: 'defaultTemplate.json',
}

export const LOCAL_STORAGE_THEME = 'UI_THEME'
export const LOCAL_STORAGE_THEME_CONFIG = 'UI_THEME_CONFIG'
export const LOCAL_STORAGE_LOGO = 'ORGANIZATION_LOGO'
